/**
 * Theme Manager — Light / Dark / Auto / High Contrast
 */
const STORAGE_KEY = 'nw-theme';

export const ThemeManager = {
  init() {
    this.apply(this.getPreferred());
    this.bindToggles();
    this.watchSystem();
  },

  getPreferred() {
    return localStorage.getItem(STORAGE_KEY) || 'auto';
  },

  set(theme) {
    localStorage.setItem(STORAGE_KEY, theme);
    this.apply(theme);
    document.dispatchEvent(new CustomEvent('nw:theme-change', { detail: { theme } }));
  },

  apply(theme) {
    const resolved = theme === 'auto'
      ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
      : theme;

    document.documentElement.setAttribute('data-bs-theme', resolved);
    document.documentElement.setAttribute('data-nw-theme', theme);

    document.querySelectorAll('[data-nw-theme-toggle]').forEach((el) => {
      el.classList.toggle('active', el.dataset.nwThemeToggle === theme);
    });
  },

  bindToggles() {
    document.querySelectorAll('[data-nw-theme-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => this.set(btn.dataset.nwThemeToggle));
    });
  },

  watchSystem() {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
      if (this.getPreferred() === 'auto') this.apply('auto');
    });
  },
};
